// extracted by mini-css-extract-plugin
export default {"title":"Injection_title__VYuZl","readingInput":"Injection_readingInput__epfPB","readingsRow":"Injection_readingsRow__cm7gC"};